export const handleOpenSocialLoginPopup = (provider: 'microsoft' | 'google') => {
  window.location.replace(`${import.meta.env.VITE_API_URL}/api/v2/auth/${provider}`);
};
